import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { GuestGuard } from '@guards/auth/guest.guard';
import { AppLayout } from '@/layout/components/app.layout';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./contexts/login/login.module').then((m) => m.LoginModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'validar-assinatura/:code/:signId',
    loadComponent: () =>
      import('./contexts/validar-assinatura/validar-assinatura.component').then((c) => c.ValidarAssinaturaComponent),
  },
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./contexts/inicio/inicio.module').then((m) => m.InicioModule),
      },
      {
        path: 'prontuario',
        loadChildren: () => import('./contexts/prontuario/prontuario.module').then((m) => m.ProntuarioModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./contexts/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'perfil',
        loadComponent: () => import('./contexts/perfil/perfil.component').then((m) => m.PerfilComponent),
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
